module.exports = __webpack_public_path__ + "static/media/bell_black.0254af6f.svg";